(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('erten-cart-offer')) {
  customElements.define('erten-cart-offer', class extends HTMLElement {
    connectedCallback() {
      this.onSubmit = async event => {
        const form = event.target.closest('.erten-cart-offer__card');
        if (!form) return;
        event.preventDefault(); event.stopPropagation();
        if (this.pending || !form.reportValidity()) return;
        this.pending = true;
        const status = this.querySelector('[role="status"]');
        const buttons = this.querySelectorAll('button');
        buttons.forEach(button => button.disabled = true);
        status.textContent = 'Ürün sepete ekleniyor…';
        try {
          const { CartUpdateEvent } = await import('@theme/events');
          const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), element => element.dataset.sectionId))].slice(0,5);
          const response = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({items:[{id:Number(new FormData(form).get('id')),quantity:1}],sections,sections_url:location.pathname})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Ürün eklenemedi. Lütfen tekrar deneyin.');
          status.textContent = 'Ürün eklendi. Sepetiniz güncelleniyor…';
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers:{'Accept':'application/json'}});
          if (!cartResponse.ok) {
            status.textContent = 'Ürün eklendi. Güncel toplamı görmek için sepeti yeniden açın.';
            this.dispatchEvent(new CartUpdateEvent({}, 'erten-cart-offer', {sections:result.sections}));
            return;
          }
          const cart = await cartResponse.json();
          this.dispatchEvent(new CartUpdateEvent(cart, 'erten-cart-offer', {itemCount:cart.item_count,sections:result.sections}));
        } catch (error) {
          status.textContent = error.message || 'Bağlantı kurulamadı. Sepetinizi kontrol ederek tekrar deneyin.';
          buttons.forEach(button => button.disabled = false);
        } finally {
          this.pending = false;
        }
      };
      this.addEventListener('submit',this.onSubmit);
    }
    disconnectedCallback() { this.removeEventListener('submit',this.onSubmit); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
